<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <!-- THIN -->
        <template v-if="weight === 'THIN'">
            <path
                d="M14.8525 14.5068C17.4414 14.6383 19.5 16.7789 19.5 19.4004V20H18.5V19.4004C18.5 17.3138 16.8614 15.6094 14.8008 15.5049L14.5996 15.5H9.40039C7.24648 15.5 5.5 17.2465 5.5 19.4004V20H4.5V19.4004C4.5 16.6942 6.6942 14.5 9.40039 14.5H14.5996L14.8525 14.5068Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 3C14.7614 3 17 5.23858 17 8C17 10.7614 14.7614 13 12 13C9.23858 13 7 10.7614 7 8C7 5.23858 9.23858 3 12 3ZM12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4Z"
                fill="currentColor"
            />
        </template>

        <!-- REGULAR -->
        <template v-else-if="weight === 'REGULAR'">
            <path
                d="M14.5996 14.25C17.4439 14.25 19.75 16.5561 19.75 19.4004V20H18.25V19.4004C18.25 17.3846 16.6154 15.75 14.5996 15.75H9.40039C7.38455 15.75 5.75 17.3846 5.75 19.4004V20H4.25V19.4004C4.25 16.5561 6.55612 14.25 9.40039 14.25H14.5996Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 3C14.7614 3 17 5.23858 17 8C17 10.7614 14.7614 13 12 13C9.23858 13 7 10.7614 7 8C7 5.23858 9.23858 3 12 3ZM12 4.5C10.067 4.5 8.5 6.067 8.5 8C8.5 9.933 10.067 11.5 12 11.5C13.933 11.5 15.5 9.933 15.5 8C15.5 6.067 13.933 4.5 12 4.5Z"
                fill="currentColor"
            />
        </template>

        <!-- FILL -->
        <template v-else>
            <path
                d="M14.5996 15C17.0297 15 19 16.9703 19 19.4004V20H5V19.4004C5 16.9703 6.97034 15 9.40039 15H14.5996Z"
                fill="currentColor"
            />
            <path
                d="M12 3C14.7614 3 17 5.23858 17 8C17 10.7614 14.7614 13 12 13C9.23858 13 7 10.7614 7 8C7 5.23858 9.23858 3 12 3Z"
                fill="currentColor"
            />
        </template>
    </svg>
</template>

<script>
    export default {
        name: 'person-icon',
        props: {
            width: {
                type: [String, Number],
                default: 24,
            },
            height: {
                type: [String, Number],
                default: 24,
            },
            color: {
                type: String,
                default: 'text-black',
            },
            weight: {
                type: String,
                default: 'THIN',
                validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
            },
        },
    };
</script>
